import React, { useEffect, useState } from 'react'
import axios from 'axios';

function PDFViewButton(props) {

    const [file, setFile] = useState({});

    useEffect(() => {
        const tokens = JSON.parse(localStorage.getItem('user'));
        if ( props.type === 'resume' && props.user_id) {
            axios.post(`${process.env.REACT_APP_API_HOST}/api/file/getFile`,
            {
                user_id: props.user_id,
                group_id: props.group_id,
                hidden: 0,
                type: props.type,//or any file category
            },
            {
                headers: {Authorization: `Bearer ${tokens.access_token}`}
            }    
            )
            .then(res => res.data)
            .then(data => {
                setFile(data[0]);
            })
            .catch(err => console.log(err))
        }
    }, [props.user_id]);

    useEffect(() => {
        if (props.file?.filepath)
            setFile(props.file);
    }, [props.file?.filepath, props.file?.filename]);

    return (
        <a href={process.env.REACT_APP_API_HOST + "/" + file.filepath} target="_blank" rel="noopener noreferrer">{file.filename}</a>
    )
}

export default PDFViewButton